import { AxiosResponse } from 'axios'
import axios from 'lib/axios'

interface GetReportsProcessResponse {
  status: number | string
  error?: any
  data?: string[]
}

type User = {
  id: number
}

interface Data {
  all?: boolean
  users?: User[]
  process_id?: number
  process_ids?: number[]
  for_missing_reports?: boolean
}

export async function getProcessReports(data: Data): Promise<GetReportsProcessResponse> {
  const PATH = `/process/users/reports/`
  try {
    const response: AxiosResponse<GetReportsProcessResponse> = await axios.post(PATH, data, {
      responseType: data.for_missing_reports ? 'json' : 'blob',
    })

    if (response.status !== 200) throw new Error('Error getting reports')
    return response.data
  } catch (error) {
    console.error('Error getting reports', error)
    return { status: 'error', error: error }
  }
}

interface GetReportsProcessFilters {
  processId?: number
  useBetesa: boolean
  useCompetences: boolean
  use360?: boolean
  isForAllProcess?: boolean
  initDate?: string
  endDate?: string
  processIds?: number[]
  zipByProcess?: boolean
}

export interface ZipReportJobStatus {
  id: number
  status: 'pending' | 'processing' | 'completed' | 'failed'
  process_ids: number[]
  total_reports: number
  completed_reports: number
  failed_reports: number
  progress_message: string | null
  progress_percent: number
  file_link: string | null
  error_message: string | null
  process_results?: Array<{
    process_id: number
    process_name: string
    total_reports: number
    completed_reports: number
    failed_reports: number
    reason: string
  }>
}

interface QueuedSummaryReportResponse {
  status: 'queued'
  message: string
  data: ZipReportJobStatus
  requestId?: string
}

const parseArrayBufferJson = (data: ArrayBuffer) => {
  const decoded = new TextDecoder().decode(data)

  return JSON.parse(decoded)
}

const parseArrayBufferError = (error: any) => {
  const data = error?.response?.data

  if (!(data instanceof ArrayBuffer)) {
    return error
  }

  try {
    const decoded = new TextDecoder().decode(data)
    const parsed = JSON.parse(decoded)

    return {
      ...error,
      decodedResponse: parsed,
      message: parsed?.message || error?.message,
    }
  } catch {
    return error
  }
}

export async function createZipReportJob(processIds: number[]): Promise<any> {
  const response: AxiosResponse<any> = await axios.post('/user/report_zip_jobs', {
    processIds,
  })

  return response.data
}

export async function getZipReportJobStatus(jobId: number): Promise<any> {
  const response: AxiosResponse<any> = await axios.get(
    `/user/report_zip_jobs/${jobId}`
  )

  return response.data
}

export async function downloadSummaryReportUser({
  processId,
  useBetesa,
  useCompetences,
  use360,
  isForAllProcess,
  initDate,
  endDate,
  processIds,
  zipByProcess,
}: GetReportsProcessFilters): Promise<any> {
  const PATH = `/user/results_summary`

  const body = {
    process_id: processId,
    is_betesa: useBetesa,
    is_competence: useCompetences,
    is_360: use360 ?? false,
  }

  const allBody = {
    is_betesa: true,
    is_competence: true,
    is_360: true,
    isForAllProcess,
    initDate,
    endDate,
    processIds,
    zipByProcess,
  }

  try {
    const response: AxiosResponse<any> = await axios.post(PATH, isForAllProcess ? allBody : body, {
      responseType: 'arraybuffer',
    })
    if (response.status === 202 && response.data instanceof ArrayBuffer) {
      return parseArrayBufferJson(response.data) as QueuedSummaryReportResponse
    }

    return response.data as ArrayBuffer
  } catch (error) {
    const parsedError = parseArrayBufferError(error)
    console.error('Error getting reports', parsedError)
    return { status: 'error', error: parsedError }
  }
}

// export async function downloadSummaryReportUser({processId, useBetesa, useCompetences}: GetReportsProcessFilters): Promise<any> {
//   const PATH = `/user/results_summary`;

//   const body = {
//     process_id: processId,
//     is_betesa: useBetesa,
//     is_competence: useCompetences,
//   };

//   try {
//     const response: AxiosResponse<any> = await axios.post(PATH, body);
//     return response.data;
//   } catch (error) {
//     console.error('Error getting reports', error);
//     return { status: 'error', error: error };
//   }
// }
